<template>
  <select
    class="form-control form-control-sm valor-relativo-select"
    :value="value"
    :disabled="disabled"
    @change="$emit('input', $event.target.value)"
  >
    <option value="">Selecione um valor relativo...</option>
    <optgroup
      v-for="grupo in OPCOES_VALOR_RELATIVO_AGRUPADAS"
      :key="grupo.label"
      :label="grupo.label"
    >
      <option
        v-for="opt in grupo.opcoes"
        :key="opt.slug"
        :value="opt.slug"
      >{{ opt.label }}</option>
    </optgroup>
  </select>
</template>

<script>
// Catalogo de valores relativos (front-side por enquanto, para reuso futuro server-side)
export const OPCOES_VALOR_RELATIVO = [
  { slug: "hoje", label: "Hoje", grupo: "dia" },
  { slug: "ontem", label: "Ontem", grupo: "dia" },
  { slug: "amanha", label: "Amanha", grupo: "dia" },

  { slug: "inicio_semana_atual", label: "Inicio da semana atual", grupo: "semana" },
  { slug: "fim_semana_atual", label: "Fim da semana atual", grupo: "semana" },
  { slug: "inicio_semana_passada", label: "Inicio da semana passada", grupo: "semana" },
  { slug: "fim_semana_passada", label: "Fim da semana passada", grupo: "semana" },

  { slug: "inicio_mes_atual", label: "Inicio do mes atual", grupo: "mes" },
  { slug: "fim_mes_atual", label: "Fim do mes atual", grupo: "mes" },
  { slug: "inicio_mes_passado", label: "Inicio do mes passado", grupo: "mes" },
  { slug: "fim_mes_passado", label: "Fim do mes passado", grupo: "mes" },

  { slug: "inicio_ano_atual", label: "Inicio do ano atual", grupo: "ano" },
  { slug: "fim_ano_atual", label: "Fim do ano atual", grupo: "ano" },
];

const GRUPOS_LABELS = {
  dia: "Dia",
  semana: "Semana",
  mes: "Mes",
  ano: "Ano",
};

export const OPCOES_VALOR_RELATIVO_AGRUPADAS = Object.keys(GRUPOS_LABELS).map((g) => ({
  label: GRUPOS_LABELS[g],
  opcoes: OPCOES_VALOR_RELATIVO.filter((o) => o.grupo === g),
}));

export default {
  name: "ValorRelativoSelect",
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      OPCOES_VALOR_RELATIVO_AGRUPADAS,
    };
  },
};
</script>

<style scoped>
.valor-relativo-select {
  font-size: 13px;
  border-radius: 6px;
}
</style>
